import React from 'react';
import './DualRangeSlider.css';

export default function DualRangeSlider({ min, max, step, value, onChange }) {
  const handleMinChange = (e) => {
    const newMin = Math.min(Number(e.target.value), value.max - step);
    onChange?.({ min: newMin, max: value.max });
  };

  const handleMaxChange = (e) => {
    const newMax = Math.max(Number(e.target.value), value.min + step);
    onChange?.({ min: value.min, max: newMax });
  };

  const getPercent = (val) => ((val - min) / (max - min)) * 100;

  return (
    <div className="dual-slider-wrapper mt-1">
      <input
        type="range"
        className="thumb thumb--left"
        min={min}
        max={max}
        step={step}
        value={value.min}
        onChange={handleMinChange}
      />
      <input
        type="range"
        className="thumb thumb--right"
        min={min}
        max={max}
        step={step}
        value={value.max}
        onChange={handleMaxChange}
      />
      <div className="slider">
        <div className="slider__track" />
        <div
          className="slider__range"
          style={{
            left: `${getPercent(value.min)}%`,
            right: `${100 - getPercent(value.max)}%`,
          }}
        />
      </div>
      <div className="d-flex justify-content-between mt-2 fs-7">
        <span className="text-muted">Min: ₹{value.min.toLocaleString()}</span>
        <span className="text-muted">Max: ₹{value.max.toLocaleString()}</span>
      </div>
    </div>
  );
}
